"use strict";
var included_coverage_component_1 = require("./included-coverage.component");
exports.IncludedCoverageComponent = included_coverage_component_1.IncludedCoverageComponent;
var optional_coverage_component_1 = require("./optional-coverage.component");
exports.OptionalCoverageComponent = optional_coverage_component_1.OptionalCoverageComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/coverages/index.js